export const SERTIFIKAT_PREFIX = "Sertifikat: ";
export const isSertifikat = (d) => (d?.jenis || "").startsWith(SERTIFIKAT_PREFIX);
export const labelSertifikat = (d) => (d?.jenis || "").slice(SERTIFIKAT_PREFIX.length) || "Sertifikat";
export const BATAS_HARI_SERTIFIKAT = 90;

export const sisaHariSertifikat = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d?.berlaku_sampai || ""));
  if (!m) return null;
  const now = new Date();
  return Math.round((Date.UTC(+m[1], +m[2] - 1, +m[3]) - Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
};

// "habis" | "segera" (≤90 hari) | "aman" | null (tanpa tanggal)
export const statusSertifikat = (d) => {
  const s = sisaHariSertifikat(d);
  if (s === null) return null;
  if (s < 0) return "habis";
  return s <= BATAS_HARI_SERTIFIKAT ? "segera" : "aman";
};

export const sertifikatPekerja = (w) => (w?.dokumen || []).filter(isSertifikat);
export const adaSertifikatKritis = (w) => sertifikatPekerja(w).some((d) => ["habis", "segera"].includes(statusSertifikat(d)));
